import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';

import { IBetslipRootState } from '../../base/store/state';
import BetbuilderActions from '../bet-builder/actions';
import {
    getSystemTypeKeyFromSlipId,
    isBetBuilderSlipId,
    isComboSlipId,
    isSingleSlipId,
    isSystemSlipId,
    isTeaserSlipId,
} from '../bet-generation/services/slip.utils';
import BetslipComboBetActions from '../combo-bet/actions';
import { ensureLinearMode, ensureTabbedMode } from '../linear/helpers';
import BetslipSingleBetActions from '../single-bet/actions';
import BetslipSystemBetActions from '../system-bet/actions';
import { BetslipTeaserActions } from '../teaser-bet/actions';
import { BetslipStakeActions } from './actions';

@Injectable()
export class MinStakeEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
    ) {}

    updateMinStakeForSingleBetSlip$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipStakeActions.updateMinStake),
            filter((action) => isSingleSlipId(action.slipId)),
            map((action) =>
                BetslipSingleBetActions.setSingleBetPickStake({
                    pickId: action.error.pickId,
                    stake: action.minStake,
                }),
            ),
        );
    });

    updateMinStakeForLinearBetBuilderSlip$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipStakeActions.updateMinStake),
            ensureLinearMode(this.store),
            filter((action) => isBetBuilderSlipId(action.slipId)),
            map((action) => BetbuilderActions.setPickStake({ pickId: action.error.pickId, stake: action.minStake })),
        );
    });

    updateMinStakeForComboBetSlip$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipStakeActions.updateMinStake),
            filter((action) => isComboSlipId(action.slipId)),
            map((action) => BetslipComboBetActions.setComboBetStake({ stake: action.minStake })),
        );
    });

    updateMinStakeForTabbedSystemBetSlip$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipStakeActions.updateMinStake),
            ensureTabbedMode(this.store),
            filter((action) => isSystemSlipId(action.slipId)),
            map((action) => BetslipSystemBetActions.setSystemBetStake({ stake: action.minStake })),
        );
    });

    updateMinStakeForLinearSystemBetSlip$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipStakeActions.updateMinStake),
            ensureLinearMode(this.store),
            filter((action) => isSystemSlipId(action.slipId)),
            map((action) =>
                BetslipSystemBetActions.setSystemBetTypeStakeValue({
                    systemTypeKey: getSystemTypeKeyFromSlipId(action.slipId)!,
                    stake: action.minStake,
                }),
            ),
        );
    });

    updateMinStakeForTeaserBetSlip$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipStakeActions.updateMinStake),
            ensureTabbedMode(this.store),
            filter((action) => isTeaserSlipId(action.slipId)),
            map((action) =>
                BetslipTeaserActions.setTeaserBetStake({
                    stake: action.minStake,
                    stakeStr: action.minStake.toString(),
                }),
            ),
        );
    });
}
